import navigate from '@/utils/navigate';
import percentage from '@/utils/percentage';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { active, inactive, integrations, never_logged_in, regular_users, total } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Users
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
                <br/>
                <Typography variant="body2">
                    Active: {active} ({percentage(active, total)})
                    <br/>
                    Inactive: {inactive} ({percentage(inactive, total)})
                </Typography>
                <br/>
                <Typography color="text.secondary" sx={{ mb: 0.5 }}>
                    Regular Users: {regular_users} ({percentage(regular_users, total)})
                    <br/>
                    Integrations: {integrations} ({percentage(integrations, total)})
                    <br/>
                    Never Logged: {never_logged_in} ({percentage(never_logged_in, total)})
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
                <Button onClick={() => navigate('/users')}>View Users</Button>
            </CardActions>
        </Card>
    );
};

export default Component;
